import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

export const PartnerCTA = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-20 right-10 w-[400px] h-[400px] bg-brand-green/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-[500px] h-[500px] bg-brand-green/10 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-8 tracking-tight">
          Jetzt Partner werden
        </h2>
        <p className="text-xl lg:text-2xl text-gray-400 mb-12 max-w-3xl mx-auto font-normal">
          Starten Sie Ihr Abo und erhalten Sie sofort Zugang zum Portal
        </p>

        <a href="/partner/abo">
          <Button size="lg" className="bg-brand-green hover:bg-brand-green-dark text-white text-lg px-10 py-7 rounded-2xl font-semibold shadow-2xl shadow-brand-green/30">
            Abo starten
            <ArrowRight className="w-5 h-5 ml-3" />
          </Button>
        </a>
      </div>
    </section>
  );
};